// Arrow Icons
import { ReactComponent as arrowCircleDownLeft } from '../../assets/icons/Arrow/Arrow_Circle_Down_Left.svg';
import { ReactComponent as arrowCircleDownRight } from '../../assets/icons/Arrow/Arrow_Circle_Down_Right.svg';
import { ReactComponent as arrowCircleLeft } from '../../assets/icons/Arrow/Arrow_Circle_Left.svg';
import { ReactComponent as arrowCircleRight } from '../../assets/icons/Arrow/Arrow_Circle_Right.svg';
import { ReactComponent as arrowCircleUp } from '../../assets/icons/Arrow/Arrow_Circle_Up.svg';
import { ReactComponent as arrowCircleDown } from '../../assets/icons/Arrow/Arrow_Circle_Down.svg';
import { ReactComponent as arrowCircleUpLeft } from '../../assets/icons/Arrow/Arrow_Circle_Up_Left.svg';
import { ReactComponent as arrowCircleUpRight } from '../../assets/icons/Arrow/Arrow_Circle_Up_Right.svg';
import { ReactComponent as arrowDown } from '../../assets/icons/Arrow/Arrow_Down_MD.svg';
import { ReactComponent as arrowDownLg } from '../../assets/icons/Arrow/Arrow_Down_LG.svg';
import { ReactComponent as arrowDownSm } from '../../assets/icons/Arrow/Arrow_Down_SM.svg';
import { ReactComponent as arrowLeft } from '../../assets/icons/Arrow/Arrow_Left_MD.svg';
import { ReactComponent as arrowLeftLg } from '../../assets/icons/Arrow/Arrow_Left_LG.svg';
import { ReactComponent as arrowLeftSm } from '../../assets/icons/Arrow/Arrow_Left_SM.svg';
import { ReactComponent as arrowRight } from '../../assets/icons/Arrow/Arrow_Right_MD.svg';
import { ReactComponent as arrowRightLg } from '../../assets/icons/Arrow/Arrow_Right_LG.svg';
import { ReactComponent as arrowRightSm } from '../../assets/icons/Arrow/Arrow_Right_SM.svg';
import { ReactComponent as arrowUp } from '../../assets/icons/Arrow/Arrow_Up_MD.svg';
import { ReactComponent as arrowUpLg } from '../../assets/icons/Arrow/Arrow_Up_LG.svg';
import { ReactComponent as arrowUpSm } from '../../assets/icons/Arrow/Arrow_Up_SM.svg';
import { ReactComponent as arrowDownLeftLg } from '../../assets/icons/Arrow/Arrow_Down_Left_LG.svg';
import { ReactComponent as arrowDownLeftMd } from '../../assets/icons/Arrow/Arrow_Down_Left_MD.svg';
import { ReactComponent as arrowDownLeftSm } from '../../assets/icons/Arrow/Arrow_Down_Left_SM.svg';
import { ReactComponent as arrowDownRightLg } from '../../assets/icons/Arrow/Arrow_Down_Right_LG.svg';
import { ReactComponent as arrowDownRightMd } from '../../assets/icons/Arrow/Arrow_Down_Right_MD.svg';
import { ReactComponent as arrowDownRightSm } from '../../assets/icons/Arrow/Arrow_Down_Right_SM.svg';
import { ReactComponent as arrowUpLeftLg } from '../../assets/icons/Arrow/Arrow_Up_Left_LG.svg';
import { ReactComponent as arrowUpLeftMd } from '../../assets/icons/Arrow/Arrow_Up_Left_MD.svg';
import { ReactComponent as arrowUpLeftSm } from '../../assets/icons/Arrow/Arrow_Up_Left_SM.svg';
import { ReactComponent as arrowUpRightLg } from '../../assets/icons/Arrow/Arrow_Up_Right_LG.svg';
import { ReactComponent as arrowUpRightMd } from '../../assets/icons/Arrow/Arrow_Up_Right_MD.svg';
import { ReactComponent as arrowUpRightSm } from '../../assets/icons/Arrow/Arrow_Up_Right_SM.svg';
import { ReactComponent as arrowDownUp } from '../../assets/icons/Arrow/Arrow_Down_Up.svg';
import { ReactComponent as arrowLeftRight } from '../../assets/icons/Arrow/Arrow_Left_Right.svg';
import { ReactComponent as arrowReload02 } from '../../assets/icons/Arrow/Arrow_Reload_02.svg';
import { ReactComponent as arrowsReload01 } from '../../assets/icons/Arrow/Arrows_Reload_01.svg';
import { ReactComponent as caretCircleDown } from '../../assets/icons/Arrow/Caret_Circle_Down.svg';
import { ReactComponent as caretCircleLeft } from '../../assets/icons/Arrow/Caret_Circle_Left.svg';
import { ReactComponent as caretCircleRight } from '../../assets/icons/Arrow/Caret_Circle_Right.svg';
import { ReactComponent as caretCircleUp } from '../../assets/icons/Arrow/Caret_Circle_Up.svg';
import { ReactComponent as caretDownMd } from '../../assets/icons/Arrow/Caret_Down_MD.svg';
import { ReactComponent as caretDownSm } from '../../assets/icons/Arrow/Caret_Down_SM.svg';
import { ReactComponent as caretLeftSm } from '../../assets/icons/Arrow/Caret_Left_SM.svg';
import { ReactComponent as caretRightSm } from '../../assets/icons/Arrow/Caret_Right_SM.svg';
import { ReactComponent as caretUpMd } from '../../assets/icons/Arrow/Caret_Up_MD.svg';
import { ReactComponent as caretUpSm } from '../../assets/icons/Arrow/Caret_Up_SM.svg';
import { ReactComponent as chevronDown } from '../../assets/icons/Arrow/Chevron_Down.svg';
import { ReactComponent as chevronDownDuo } from '../../assets/icons/Arrow/Chevron_Down_Duo.svg';
import { ReactComponent as chevronLeft } from '../../assets/icons/Arrow/Chevron_Left.svg';
import { ReactComponent as chevronLeftDuo } from '../../assets/icons/Arrow/Chevron_Left_Duo.svg';
import { ReactComponent as chevronLeftMd } from '../../assets/icons/Arrow/Chevron_Left_MD.svg';
import { ReactComponent as chevronRight } from '../../assets/icons/Arrow/Chevron_Right.svg';
import { ReactComponent as chevronRightDuo } from '../../assets/icons/Arrow/Chevron_Right_Duo.svg';
import { ReactComponent as chevronRightMd } from '../../assets/icons/Arrow/Chevron_Right_MD.svg';
import { ReactComponent as chevronUp } from '../../assets/icons/Arrow/Chevron_Up.svg';
import { ReactComponent as chevronUpDuo } from '../../assets/icons/Arrow/Chevron_Up_Duo.svg';
import { ReactComponent as expand } from '../../assets/icons/Arrow/Expand.svg';
import { ReactComponent as shrink } from '../../assets/icons/Arrow/Shrink.svg';
import { ReactComponent as unfoldLess } from '../../assets/icons/Arrow/Unfold_Less.svg';
import { ReactComponent as unfoldMore } from '../../assets/icons/Arrow/Unfold_More.svg';

// Calendar Icons
import { ReactComponent as alarm } from '../../assets/icons/Calendar/Alarm.svg';
import { ReactComponent as calendar } from '../../assets/icons/Calendar/Calendar.svg';
import { ReactComponent as calendarAdd } from '../../assets/icons/Calendar/Calendar_Add.svg';
import { ReactComponent as calendarCheck } from '../../assets/icons/Calendar/Calendar_Check.svg';
import { ReactComponent as calendarClose } from '../../assets/icons/Calendar/Calendar_Close.svg';
import { ReactComponent as calendarDays } from '../../assets/icons/Calendar/Calendar_Days.svg';
import { ReactComponent as calendarEvent } from '../../assets/icons/Calendar/Calendar_Event.svg';
import { ReactComponent as calendarRemove } from '../../assets/icons/Calendar/Calendar_Remove.svg';
import { ReactComponent as calendarWeek } from '../../assets/icons/Calendar/Calendar_Week.svg';
import { ReactComponent as clock } from '../../assets/icons/Calendar/Clock.svg';
import { ReactComponent as timer } from '../../assets/icons/Calendar/Timer.svg';
import { ReactComponent as timerAdd } from '../../assets/icons/Calendar/Timer_Add.svg';
import { ReactComponent as timerClose } from '../../assets/icons/Calendar/Timer_Close.svg';
import { ReactComponent as timerRemove } from '../../assets/icons/Calendar/Timer_Remove.svg';

// Communication Icons
import { ReactComponent as bell } from '../../assets/icons/Communication/Bell.svg';
import { ReactComponent as bellAdd } from '../../assets/icons/Communication/Bell_Add.svg';
import { ReactComponent as bellClose } from '../../assets/icons/Communication/Bell_Close.svg';
import { ReactComponent as bellNotification } from '../../assets/icons/Communication/Bell_Notification.svg';
import { ReactComponent as bellOff } from '../../assets/icons/Communication/Bell_Off.svg';
import { ReactComponent as bellRemove } from '../../assets/icons/Communication/Bell_Remove.svg';
import { ReactComponent as bellRing } from '../../assets/icons/Communication/Bell_Ring.svg';
import { ReactComponent as chat } from '../../assets/icons/Communication/Chat.svg';
import { ReactComponent as chatAdd } from '../../assets/icons/Communication/Chat_Add.svg';
import { ReactComponent as chatCheck } from '../../assets/icons/Communication/Chat_Check.svg';
import { ReactComponent as chatCircle } from '../../assets/icons/Communication/Chat_Circle.svg';
import { ReactComponent as chatCircleAdd } from '../../assets/icons/Communication/Chat_Circle_Add.svg';
import { ReactComponent as chatCircleCheck } from '../../assets/icons/Communication/Chat_Circle_Check.svg';
import { ReactComponent as chatCircleClose } from '../../assets/icons/Communication/Chat_Circle_Close.svg';
import { ReactComponent as chatCircleDots } from '../../assets/icons/Communication/Chat_Circle_Dots.svg';
import { ReactComponent as chatCircleRemove } from '../../assets/icons/Communication/Chat_Circle_Remove.svg';
import { ReactComponent as chatClose } from '../../assets/icons/Communication/Chat_Close.svg';
import { ReactComponent as message } from '../../assets/icons/Communication/Chat_Conversation.svg';
import { ReactComponent as chatConversationCircle } from '../../assets/icons/Communication/Chat_Conversation_Circle.svg';
import { ReactComponent as chatDots } from '../../assets/icons/Communication/Chat_Dots.svg';
import { ReactComponent as chatRemove } from '../../assets/icons/Communication/Chat_Remove.svg';
import { ReactComponent as mail } from '../../assets/icons/Communication/Mail.svg';
import { ReactComponent as mailOpen } from '../../assets/icons/Communication/Mail_Open.svg';
import { ReactComponent as paperPlane } from '../../assets/icons/Communication/Paper_Plane.svg';
import { ReactComponent as phone } from '../../assets/icons/Communication/Phone.svg';
import { ReactComponent as send } from '../../assets/icons/Communication/Send.svg';
import { ReactComponent as shareAndroid } from '../../assets/icons/Communication/Share_Android.svg';
import { ReactComponent as shareIOS } from '../../assets/icons/Communication/Share_iOS_Export.svg';

// Edit Icons
import { ReactComponent as copy } from '../../assets/icons/Edit/Copy.svg';
import { ReactComponent as cut } from '../../assets/icons/Edit/Crop.svg';
import { ReactComponent as deleteIcon } from '../../assets/icons/Edit/Delete_Row.svg';
import { ReactComponent as edit } from '../../assets/icons/Edit/Edit_Pencil_01.svg';
import { ReactComponent as editPencil } from '../../assets/icons/Edit/Edit_Pencil_02.svg';
import { ReactComponent as paste } from '../../assets/icons/Edit/Copy.svg';
import { ReactComponent as redo } from '../../assets/icons/Edit/Redo.svg';
import { ReactComponent as undo } from '../../assets/icons/Edit/Undo.svg';
import { ReactComponent as minus } from '../../assets/icons/Edit/Remove_Minus.svg';
import { ReactComponent as minusSm } from '../../assets/icons/Edit/Remove_Minus_Circle.svg';
import { ReactComponent as plus } from '../../assets/icons/Edit/Add_Plus.svg';
import { ReactComponent as plusSm } from '../../assets/icons/Edit/Add_Plus_Circle.svg';

// Environment Icons
import { ReactComponent as bulb } from '../../assets/icons/Environment/Bulb.svg';
import { ReactComponent as coffeeToGo } from '../../assets/icons/Environment/Coffe_To_Go.svg';
import { ReactComponent as coffee } from '../../assets/icons/Environment/Coffee.svg';
import { ReactComponent as cookie } from '../../assets/icons/Environment/Cookie.svg';
import { ReactComponent as cupcake } from '../../assets/icons/Environment/Cupcake.svg';
import { ReactComponent as firstAid } from '../../assets/icons/Environment/First_Aid.svg';
import { ReactComponent as leaf } from '../../assets/icons/Environment/Leaf.svg';
import { ReactComponent as moon } from '../../assets/icons/Environment/Moon.svg';
import { ReactComponent as planet } from '../../assets/icons/Environment/Planet.svg';
import { ReactComponent as puzzle } from '../../assets/icons/Environment/Puzzle.svg';
import { ReactComponent as rainbow } from '../../assets/icons/Environment/Rainbow.svg';
import { ReactComponent as sun } from '../../assets/icons/Environment/Sun.svg';
import { ReactComponent as waterDrop } from '../../assets/icons/Environment/Water_Drop.svg';

// File Icons
import { ReactComponent as archive } from '../../assets/icons/File/Archive.svg';
import { ReactComponent as cloud } from '../../assets/icons/File/Cloud.svg';
import { ReactComponent as cloudAdd } from '../../assets/icons/File/Cloud_Add.svg';
import { ReactComponent as cloudCheck } from '../../assets/icons/File/Cloud_Check.svg';
import { ReactComponent as cloudClose } from '../../assets/icons/File/Cloud_Close.svg';
import { ReactComponent as cloudDownload } from '../../assets/icons/File/Cloud_Download.svg';
import { ReactComponent as cloudOff } from '../../assets/icons/File/Cloud_Off.svg';
import { ReactComponent as cloudRemove } from '../../assets/icons/File/Cloud_Remove.svg';
import { ReactComponent as cloudUpload } from '../../assets/icons/File/Cloud_Upload.svg';
import { ReactComponent as fileAdd } from '../../assets/icons/File/File_Add.svg';
import { ReactComponent as fileBlank } from '../../assets/icons/File/File_Blank.svg';
import { ReactComponent as fileCheck } from '../../assets/icons/File/File_Check.svg';
import { ReactComponent as fileClose } from '../../assets/icons/File/File_Close.svg';
import { ReactComponent as fileCode } from '../../assets/icons/File/File_Code.svg';
import { ReactComponent as fileDocument } from '../../assets/icons/File/File_Document.svg';
import { ReactComponent as fileDownload } from '../../assets/icons/File/File_Download.svg';
import { ReactComponent as fileEdit } from '../../assets/icons/File/File_Edit.svg';
import { ReactComponent as fileRemove } from '../../assets/icons/File/File_Remove.svg';
import { ReactComponent as fileSearch } from '../../assets/icons/File/File_Search.svg';
import { ReactComponent as fileUpload } from '../../assets/icons/File/File_Upload.svg';
import { ReactComponent as files } from '../../assets/icons/File/Files.svg';
import { ReactComponent as folder } from '../../assets/icons/File/Folder.svg';
import { ReactComponent as folderAdd } from '../../assets/icons/File/Folder_Add.svg';
import { ReactComponent as folderCheck } from '../../assets/icons/File/Folder_Check.svg';
import { ReactComponent as folderClose } from '../../assets/icons/File/Folder_Close.svg';
import { ReactComponent as folderCode } from '../../assets/icons/File/Folder_Code.svg';
import { ReactComponent as folderDocument } from '../../assets/icons/File/Folder_Document.svg';
import { ReactComponent as folderDownload } from '../../assets/icons/File/Folder_Download.svg';
import { ReactComponent as folderEdit } from '../../assets/icons/File/Folder_Edit.svg';
import { ReactComponent as folderOpen } from '../../assets/icons/File/Folder_Open.svg';
import { ReactComponent as folderRemove } from '../../assets/icons/File/Folder_Remove.svg';
import { ReactComponent as folderSearch } from '../../assets/icons/File/Folder_Search.svg';
import { ReactComponent as folderUpload } from '../../assets/icons/File/Folder_Upload.svg';
import { ReactComponent as folders } from '../../assets/icons/File/Folders.svg';
import { ReactComponent as note } from '../../assets/icons/File/Note.svg';
import { ReactComponent as noteEdit } from '../../assets/icons/File/Note_Edit.svg';
import { ReactComponent as noteSearch } from '../../assets/icons/File/Note_Search.svg';
import { ReactComponent as notebook } from '../../assets/icons/File/Notebook.svg';

// Interface Icons
import { ReactComponent as book } from '../../assets/icons/Interface/Book.svg';
import { ReactComponent as bookOpen } from '../../assets/icons/Interface/Book_Open.svg';
import { ReactComponent as bookmark } from '../../assets/icons/Interface/Bookmark.svg';
import { ReactComponent as chartBarHorizontal } from '../../assets/icons/Interface/Chart_Bar_Horizontal_01.svg';
import { ReactComponent as chartBarVertical } from '../../assets/icons/Interface/Chart_Bar_Vertical_01.svg';
import { ReactComponent as chartLine } from '../../assets/icons/Interface/Chart_Line.svg';
import { ReactComponent as chartPie } from '../../assets/icons/Interface/Chart_Pie.svg';
import { ReactComponent as check } from '../../assets/icons/Interface/Check.svg';
import { ReactComponent as checkAll } from '../../assets/icons/Interface/Check_All.svg';
import { ReactComponent as checkAllBig } from '../../assets/icons/Interface/Check_All_Big.svg';
import { ReactComponent as checkBig } from '../../assets/icons/Interface/Check_Big.svg';
import { ReactComponent as checkboxCheck } from '../../assets/icons/Interface/Checkbox_Check.svg';
import { ReactComponent as checkboxFill } from '../../assets/icons/Interface/Checkbox_Fill.svg';
import { ReactComponent as checkboxUnchecked } from '../../assets/icons/Interface/Checkbox_Unchecked.svg';
import { ReactComponent as command } from '../../assets/icons/Interface/Command.svg';
import { ReactComponent as creditCard01 } from '../../assets/icons/Interface/Credit_Card_01.svg';
import { ReactComponent as creditCard02 } from '../../assets/icons/Interface/Credit_Card_02.svg';
import { ReactComponent as download } from '../../assets/icons/Interface/Download.svg';
import { ReactComponent as dragHorizontal } from '../../assets/icons/Interface/Drag_Horizontal.svg';
import { ReactComponent as dragVertical } from '../../assets/icons/Interface/Drag_Vertical.svg';
import { ReactComponent as dummyCircle } from '../../assets/icons/Interface/Dummy_Circle.svg';
import { ReactComponent as dummyCircleSmall } from '../../assets/icons/Interface/Dummy_Circle_Small.svg';
import { ReactComponent as dummySquare } from '../../assets/icons/Interface/Dummy_Square.svg';
import { ReactComponent as dummySquareSmall } from '../../assets/icons/Interface/Dummy_Square_Small.svg';
import { ReactComponent as exit } from '../../assets/icons/Interface/Exit.svg';
import { ReactComponent as externalLink } from '../../assets/icons/Interface/External_Link.svg';
import { ReactComponent as filter } from '../../assets/icons/Interface/Filter.svg';
import { ReactComponent as filterOff } from '../../assets/icons/Interface/Filter_Off.svg';
import { ReactComponent as gift } from '../../assets/icons/Interface/Gift.svg';
import { ReactComponent as handbag } from '../../assets/icons/Interface/Handbag.svg';
import { ReactComponent as heart01 } from '../../assets/icons/Interface/Heart_01.svg';
import { ReactComponent as heart02 } from '../../assets/icons/Interface/Heart_02.svg';
import { ReactComponent as instance } from '../../assets/icons/Interface/Instance.svg';
import { ReactComponent as label } from '../../assets/icons/Interface/Label.svg';
import { ReactComponent as lineL } from '../../assets/icons/Interface/Line_L.svg';
import { ReactComponent as lineM } from '../../assets/icons/Interface/Line_M.svg';
import { ReactComponent as lineS } from '../../assets/icons/Interface/Line_S.svg';
import { ReactComponent as lineXl } from '../../assets/icons/Interface/Line_Xl.svg';
import { ReactComponent as link } from '../../assets/icons/Interface/Link.svg';
import { ReactComponent as linkBreak } from '../../assets/icons/Interface/Link_Break.svg';
import { ReactComponent as linkHorizontal } from '../../assets/icons/Interface/Link_Horizontal.svg';
import { ReactComponent as linkHorizontalOff } from '../../assets/icons/Interface/Link_Horizontal_Off.svg';
import { ReactComponent as linkVertical } from '../../assets/icons/Interface/Link_Vertical.svg';
import { ReactComponent as loading } from '../../assets/icons/Interface/Loading.svg';
import { ReactComponent as lock } from '../../assets/icons/Interface/Lock.svg';
import { ReactComponent as lockOpen } from '../../assets/icons/Interface/Lock_Open.svg';
import { ReactComponent as logOut } from '../../assets/icons/Interface/Log_Out.svg';
import { ReactComponent as magnifyingGlassMinus } from '../../assets/icons/Interface/Magnifying_Glass_Minus.svg';
import { ReactComponent as magnifyingGlassPlus } from '../../assets/icons/Interface/Magnifying_Glass_Plus.svg';
import { ReactComponent as mainComponent } from '../../assets/icons/Interface/Main_Component.svg';
import { ReactComponent as option } from '../../assets/icons/Interface/Option.svg';
import { ReactComponent as radioFill } from '../../assets/icons/Interface/Radio_Fill.svg';
import { ReactComponent as radioUnchecked } from '../../assets/icons/Interface/Radio_Unchecked.svg';
import { ReactComponent as search } from '../../assets/icons/Interface/Search_Magnifying_Glass.svg';
import { ReactComponent as settings } from '../../assets/icons/Interface/Settings.svg';
import { ReactComponent as settingsFuture } from '../../assets/icons/Interface/Settings_Future.svg';
import { ReactComponent as shoppingBag01 } from '../../assets/icons/Interface/Shopping_Bag_01.svg';
import { ReactComponent as shoppingBag02 } from '../../assets/icons/Interface/Shopping_Bag_02.svg';
import { ReactComponent as shoppingCart01 } from '../../assets/icons/Interface/Shopping_Cart_01.svg';
import { ReactComponent as shoppingCart02 } from '../../assets/icons/Interface/Shopping_Cart_02.svg';
import { ReactComponent as slider01 } from '../../assets/icons/Interface/Slider_01.svg';
import { ReactComponent as slider02 } from '../../assets/icons/Interface/Slider_02.svg';
import { ReactComponent as slider03 } from '../../assets/icons/Interface/Slider_03.svg';
import { ReactComponent as star } from '../../assets/icons/Interface/Star.svg';
import { ReactComponent as suitcase } from '../../assets/icons/Interface/Suitcase.svg';
import { ReactComponent as swichtLeft } from '../../assets/icons/Interface/Swicht_Left.svg';
import { ReactComponent as swichtRight } from '../../assets/icons/Interface/Swicht_Right.svg';
import { ReactComponent as tag } from '../../assets/icons/Interface/Tag.svg';
import { ReactComponent as ticketVoucher } from '../../assets/icons/Interface/Ticket_Voucher.svg';
import { ReactComponent as trashEmpty } from '../../assets/icons/Interface/Trash_Empty.svg';
import { ReactComponent as trashFull } from '../../assets/icons/Interface/Trash_Full.svg';
import { ReactComponent as trendingDown } from '../../assets/icons/Interface/Trending_Down.svg';
import { ReactComponent as trendingUp } from '../../assets/icons/Interface/Trending_Up.svg';

// Media Icons
import { ReactComponent as airplay } from '../../assets/icons/Media/Airplay.svg';
import { ReactComponent as chromecast } from '../../assets/icons/Media/Chromecast.svg';
import { ReactComponent as forward } from '../../assets/icons/Media/Forward.svg';
import { ReactComponent as headphones } from '../../assets/icons/Media/Headphones.svg';
import { ReactComponent as image01 } from '../../assets/icons/Media/Image_01.svg';
import { ReactComponent as image } from '../../assets/icons/Media/Image_02.svg';
import { ReactComponent as microphone } from '../../assets/icons/Media/Volume_Max.svg';
import { ReactComponent as microphoneOff } from '../../assets/icons/Media/Volume_Off.svg';
import { ReactComponent as music } from '../../assets/icons/Media/Play.svg';
import { ReactComponent as pauseIcon } from '../../assets/icons/Media/Pause.svg';
import { ReactComponent as pauseCircle } from '../../assets/icons/Media/Pause_Circle.svg';
import { ReactComponent as playIcon } from '../../assets/icons/Media/Play.svg';
import { ReactComponent as playCircle } from '../../assets/icons/Media/Play_Circle.svg';
import { ReactComponent as rewind } from '../../assets/icons/Media/Rewind.svg';
import { ReactComponent as shuffle } from '../../assets/icons/Media/Shuffle.svg';
import { ReactComponent as skipBack } from '../../assets/icons/Media/Skip_Back.svg';
import { ReactComponent as skipForward } from '../../assets/icons/Media/Skip_Forward.svg';
import { ReactComponent as stopIcon } from '../../assets/icons/Media/Stop.svg';
import { ReactComponent as stopCircle } from '../../assets/icons/Media/Stop_Circle.svg';
import { ReactComponent as video } from '../../assets/icons/Media/Airplay.svg';
import { ReactComponent as videoOff } from '../../assets/icons/Media/Volume_Off_02.svg';
import { ReactComponent as volumeMax } from '../../assets/icons/Media/Volume_Max.svg';
import { ReactComponent as volumeMin } from '../../assets/icons/Media/Volume_Min.svg';
import { ReactComponent as volumeMinus } from '../../assets/icons/Media/Volume_Minus.svg';
import { ReactComponent as volumeOff } from '../../assets/icons/Media/Volume_Off.svg';
import { ReactComponent as volumeOff02 } from '../../assets/icons/Media/Volume_Off_02.svg';
import { ReactComponent as volumePlus } from '../../assets/icons/Media/Volume_Plus.svg';

// Menu Icons
import { ReactComponent as menu } from '../../assets/icons/Menu/Hamburger_LG.svg';
import { ReactComponent as menuMd } from '../../assets/icons/Menu/Hamburger_MD.svg';
import { ReactComponent as menuAlt1 } from '../../assets/icons/Menu/Menu_Alt_01.svg';
import { ReactComponent as menuAlt2 } from '../../assets/icons/Menu/Menu_Alt_02.svg';
import { ReactComponent as menuAlt3 } from '../../assets/icons/Menu/Menu_Alt_03.svg';
import { ReactComponent as menuAlt4 } from '../../assets/icons/Menu/Menu_Alt_04.svg';
import { ReactComponent as menuAlt5 } from '../../assets/icons/Menu/Menu_Alt_05.svg';
import { ReactComponent as menuDuoLg } from '../../assets/icons/Menu/Menu_Duo_LG.svg';
import { ReactComponent as menuDuoMd } from '../../assets/icons/Menu/Menu_Duo_MD.svg';
import { ReactComponent as close } from '../../assets/icons/Menu/Close_LG.svg';
import { ReactComponent as closeMd } from '../../assets/icons/Menu/Close_MD.svg';
import { ReactComponent as closeSm } from '../../assets/icons/Menu/Close_SM.svg';
import { ReactComponent as moreGridBig } from '../../assets/icons/Menu/More_Grid_Big.svg';
import { ReactComponent as moreGridSmall } from '../../assets/icons/Menu/More_Grid_Small.svg';
import { ReactComponent as ellipsis } from '../../assets/icons/Menu/More_Horizontal.svg';
import { ReactComponent as moreVertical } from '../../assets/icons/Menu/More_Vertical.svg';

// Navigation Icons
import { ReactComponent as building01 } from '../../assets/icons/Navigation/Building_01.svg';
import { ReactComponent as building02 } from '../../assets/icons/Navigation/Building_02.svg';
import { ReactComponent as building03 } from '../../assets/icons/Navigation/Building_03.svg';
import { ReactComponent as building04 } from '../../assets/icons/Navigation/Building_04.svg';
import { ReactComponent as carAuto } from '../../assets/icons/Navigation/Car_Auto.svg';
import { ReactComponent as compass } from '../../assets/icons/Navigation/Compass.svg';
import { ReactComponent as flag } from '../../assets/icons/Navigation/Flag.svg';
import { ReactComponent as globe } from '../../assets/icons/Navigation/Globe.svg';
import { ReactComponent as home } from '../../assets/icons/Navigation/House_01.svg';
import { ReactComponent as homeAlt1 } from '../../assets/icons/Navigation/House_02.svg';
import { ReactComponent as homeAlt2 } from '../../assets/icons/Navigation/House_03.svg';
import { ReactComponent as homeAdd } from '../../assets/icons/Navigation/House_Add.svg';
import { ReactComponent as homeCheck } from '../../assets/icons/Navigation/House_Check.svg';
import { ReactComponent as homeClose } from '../../assets/icons/Navigation/House_Close.svg';
import { ReactComponent as homeRemove } from '../../assets/icons/Navigation/House_Remove.svg';
import { ReactComponent as map } from '../../assets/icons/Navigation/Map.svg';
import { ReactComponent as mapPin } from '../../assets/icons/Navigation/Map_Pin.svg';
import { ReactComponent as navigation } from '../../assets/icons/Navigation/Navigation.svg';

// Shape Icons
import { ReactComponent as circle } from '../../assets/icons/Shape/Circle.svg';
import { ReactComponent as octagon } from '../../assets/icons/Shape/Octagon.svg';
import { ReactComponent as shield } from '../../assets/icons/Shape/Shield.svg';
import { ReactComponent as square } from '../../assets/icons/Shape/Square.svg';
import { ReactComponent as triangle } from '../../assets/icons/Shape/Triangle.svg';
import { ReactComponent as wavy } from '../../assets/icons/Shape/Wavy.svg';
import {ReactComponent as Negative} from '../../assets/icons/Shape/Negative.svg';
import {ReactComponent as Positive} from '../../assets/icons/Shape/Plus.svg';

// System Icons
import { ReactComponent as barBottom } from '../../assets/icons/System/Bar_Bottom.svg';
import { ReactComponent as barLeft } from '../../assets/icons/System/Bar_Left.svg';
import { ReactComponent as barRight } from '../../assets/icons/System/Bar_Right.svg';
import { ReactComponent as barTop } from '../../assets/icons/System/Bar_Top.svg';
import { ReactComponent as systemCamera } from '../../assets/icons/System/Camera.svg';
import { ReactComponent as code } from '../../assets/icons/System/Code.svg';
import { ReactComponent as cylinder } from '../../assets/icons/System/Cylinder.svg';
import { ReactComponent as data } from '../../assets/icons/System/Data.svg';
import { ReactComponent as desktop } from '../../assets/icons/System/Desktop.svg';
import { ReactComponent as desktopTower } from '../../assets/icons/System/Desktop_Tower.svg';
import { ReactComponent as devices } from '../../assets/icons/System/Devices.svg';
import { ReactComponent as keyboard } from '../../assets/icons/System/Keyboard.svg';
import { ReactComponent as laptop } from '../../assets/icons/System/Laptop.svg';
import { ReactComponent as mobile } from '../../assets/icons/System/Mobile.svg';
import { ReactComponent as mobileButton } from '../../assets/icons/System/Mobile_Button.svg';
import { ReactComponent as monitor } from '../../assets/icons/System/Monitor.svg';
import { ReactComponent as monitorPlay } from '../../assets/icons/System/Monitor_Play.svg';
import { ReactComponent as mouse } from '../../assets/icons/System/Mouse.svg';
import { ReactComponent as movingDesk } from '../../assets/icons/System/Moving_Desk.svg';
import { ReactComponent as printer } from '../../assets/icons/System/Printer.svg';
import { ReactComponent as qrCode } from '../../assets/icons/System/Qr_Code.svg';
import { ReactComponent as save } from '../../assets/icons/System/Save.svg';
import { ReactComponent as tablet } from '../../assets/icons/System/Tablet.svg';
import { ReactComponent as tabletButton } from '../../assets/icons/System/Tablet_Button.svg';
import { ReactComponent as terminal } from '../../assets/icons/System/Terminal.svg';
import { ReactComponent as wifiHigh } from '../../assets/icons/System/Wifi_High.svg';
import { ReactComponent as wifiLow } from '../../assets/icons/System/Wifi_Low.svg';
import { ReactComponent as wifiMedium } from '../../assets/icons/System/Wifi_Medium.svg';
import { ReactComponent as wifiNone } from '../../assets/icons/System/Wifi_None.svg';
import { ReactComponent as wifiOff } from '../../assets/icons/System/Wifi_Off.svg';
import { ReactComponent as wifiProblem } from '../../assets/icons/System/Wifi_Problem.svg';
import { ReactComponent as window } from '../../assets/icons/System/Window.svg';
import { ReactComponent as windowCheck } from '../../assets/icons/System/Window_Check.svg';
import { ReactComponent as windowClose } from '../../assets/icons/System/Window_Close.svg';
import { ReactComponent as windowCodeBlock } from '../../assets/icons/System/Window_Code_Block.svg';
import { ReactComponent as windowSidebar } from '../../assets/icons/System/Window_Sidebar.svg';
import { ReactComponent as windowTerminal } from '../../assets/icons/System/Window_Terminal.svg';

// User Icons
import { ReactComponent as user01 } from '../../assets/icons/User/User_01.svg';
import { ReactComponent as user02 } from '../../assets/icons/User/User_02.svg';
import { ReactComponent as user03 } from '../../assets/icons/User/User_03.svg';
import { ReactComponent as userAdd } from '../../assets/icons/User/User_Add.svg';
import { ReactComponent as userCardId } from '../../assets/icons/User/User_Card_ID.svg';
import { ReactComponent as userCheck } from '../../assets/icons/User/User_Check.svg';
import { ReactComponent as userCircle } from '../../assets/icons/User/User_Circle.svg';
import { ReactComponent as userClose } from '../../assets/icons/User/User_Close.svg';
import { ReactComponent as userRemove } from '../../assets/icons/User/User_Remove.svg';
import { ReactComponent as userSquare } from '../../assets/icons/User/User_Square.svg';
import { ReactComponent as userVoice } from '../../assets/icons/User/User_Voice.svg';
import { ReactComponent as users } from '../../assets/icons/User/Users.svg';
import { ReactComponent as usersGroup } from '../../assets/icons/User/Users_Group.svg';

// Warning Icons
import { ReactComponent as circleCheck } from '../../assets/icons/Warning/Circle_Check.svg';
import { ReactComponent as question } from '../../assets/icons/Warning/Circle_Help.svg';
import { ReactComponent as alert } from '../../assets/icons/Warning/Circle_Warning.svg';
import { ReactComponent as help } from '../../assets/icons/Warning/Help.svg';
import { ReactComponent as info } from '../../assets/icons/Warning/Info.svg';
import { ReactComponent as octagonCheck } from '../../assets/icons/Warning/Octagon_Check.svg';
import { ReactComponent as octagonHelp } from '../../assets/icons/Warning/Octagon_Help.svg';
import { ReactComponent as octagonWarning } from '../../assets/icons/Warning/Octagon_Warning.svg';
import { ReactComponent as shieldCheck } from '../../assets/icons/Warning/Shield_Check.svg';
import { ReactComponent as shieldWarning } from '../../assets/icons/Warning/Shield_Warning.svg';
import { ReactComponent as squareCheck } from '../../assets/icons/Warning/Square_Check.svg';
import { ReactComponent as squareHelp } from '../../assets/icons/Warning/Square_Help.svg';
import { ReactComponent as squareWarning } from '../../assets/icons/Warning/Square_Warning.svg';
import { ReactComponent as stopSign } from '../../assets/icons/Warning/Stop_Sign.svg';
import { ReactComponent as triangleCheck } from '../../assets/icons/Warning/Triangle_Check.svg';
import { ReactComponent as alertTriangle } from '../../assets/icons/Warning/Triangle_Warning.svg';
import { ReactComponent as warning } from '../../assets/icons/Warning/Warning.svg';
import { ReactComponent as wavyCheck } from '../../assets/icons/Warning/Wavy_Check.svg';
import { ReactComponent as wavyHelp } from '../../assets/icons/Warning/Wavy_Help.svg';
import { ReactComponent as wavyWarning } from '../../assets/icons/Warning/Wavy_Warning.svg';

const icons = {
  // Arrow Icons
  'Arrow_Circle_Down_Left': arrowCircleDownLeft,
  'Arrow_Circle_Down_Right': arrowCircleDownRight,
  'Arrow_Circle_Left': arrowCircleLeft,
  'Arrow_Circle_Right': arrowCircleRight,
  'Arrow_Circle_Up': arrowCircleUp,
  'Arrow_Circle_Down': arrowCircleDown,
  'Arrow_Circle_Up_Left': arrowCircleUpLeft,
  'Arrow_Circle_Up_Right': arrowCircleUpRight,
  'Arrow_Down_MD': arrowDown,
  'Arrow_Down_LG': arrowDownLg,
  'Arrow_Down_SM': arrowDownSm,
  'Arrow_Left_MD': arrowLeft,
  'Arrow_Left_LG': arrowLeftLg,
  'Arrow_Left_SM': arrowLeftSm,
  'Arrow_Right_MD': arrowRight,
  'Arrow_Right_LG': arrowRightLg,
  'Arrow_Right_SM': arrowRightSm,
  'Arrow_Up_MD': arrowUp,
  'Arrow_Up_LG': arrowUpLg,
  'Arrow_Up_SM': arrowUpSm,
  'Arrow_Down_Left_LG': arrowDownLeftLg,
  'Arrow_Down_Left_MD': arrowDownLeftMd,
  'Arrow_Down_Left_SM': arrowDownLeftSm,
  'Arrow_Down_Right_LG': arrowDownRightLg,
  'Arrow_Down_Right_MD': arrowDownRightMd,
  'Arrow_Down_Right_SM': arrowDownRightSm,
  'Arrow_Up_Left_LG': arrowUpLeftLg,
  'Arrow_Up_Left_MD': arrowUpLeftMd,
  'Arrow_Up_Left_SM': arrowUpLeftSm,
  'Arrow_Up_Right_LG': arrowUpRightLg,
  'Arrow_Up_Right_MD': arrowUpRightMd,
  'Arrow_Up_Right_SM': arrowUpRightSm,
  'Arrow_Down_Up': arrowDownUp,
  'Arrow_Left_Right': arrowLeftRight,
  'Arrow_Reload_02': arrowReload02,
  'Arrows_Reload_01': arrowsReload01,
  'Caret_Circle_Down': caretCircleDown,
  'Caret_Circle_Left': caretCircleLeft,
  'Caret_Circle_Right': caretCircleRight,
  'Caret_Circle_Up': caretCircleUp,
  'Caret_Down_MD': caretDownMd,
  'Caret_Down_SM': caretDownSm,
  'Caret_Left_SM': caretLeftSm,
  'Caret_Right_SM': caretRightSm,
  'Caret_Up_MD': caretUpMd,
  'Caret_Up_SM': caretUpSm,
  'Chevron_Down': chevronDown,
  'Chevron_Down_Duo': chevronDownDuo,
  'Chevron_Left': chevronLeft,
  'Chevron_Left_Duo': chevronLeftDuo,
  'Chevron_Left_MD': chevronLeftMd,
  'Chevron_Right': chevronRight,
  'Chevron_Right_Duo': chevronRightDuo,
  'Chevron_Right_MD': chevronRightMd,
  'Chevron_Up': chevronUp,
  'Chevron_Up_Duo': chevronUpDuo,
  'Expand': expand,
  'Shrink': shrink,
  'Unfold_Less': unfoldLess,
  'Unfold_More': unfoldMore,

  // Calendar Icons
  'Alarm': alarm,
  'Calendar': calendar,
  'Calendar_Add': calendarAdd,
  'Calendar_Check': calendarCheck,
  'Calendar_Close': calendarClose,
  'Calendar_Days': calendarDays,
  'Calendar_Event': calendarEvent,
  'Calendar_Remove': calendarRemove,
  'Calendar_Week': calendarWeek,
  'Clock': clock,
  'Timer': timer,
  'Timer_Add': timerAdd,
  'Timer_Close': timerClose,
  'Timer_Remove': timerRemove,

  // Communication Icons
  'Bell': bell,
  'Bell_Add': bellAdd,
  'Bell_Close': bellClose,
  'Bell_Notification': bellNotification,
  'Bell_Off': bellOff,
  'Bell_Remove': bellRemove,
  'Bell_Ring': bellRing,
  'Chat': chat,
  'Chat_Add': chatAdd,
  'Chat_Check': chatCheck,
  'Chat_Circle': chatCircle,
  'Chat_Circle_Add': chatCircleAdd,
  'Chat_Circle_Check': chatCircleCheck,
  'Chat_Circle_Close': chatCircleClose,
  'Chat_Circle_Dots': chatCircleDots,
  'Chat_Circle_Remove': chatCircleRemove,
  'Chat_Close': chatClose,
  'Chat_Conversation': message,
  'Chat_Conversation_Circle': chatConversationCircle,
  'Chat_Dots': chatDots,
  'Chat_Remove': chatRemove,
  'Mail': mail,
  'Mail_Open': mailOpen,
  'Paper_Plane': paperPlane,
  'Phone': phone,
  'Send': send,
  'Share_Android': shareAndroid,
  'Share_iOS_Export': shareIOS,

  // Edit Icons
  'Copy': copy,
  'Crop': cut,
  'Delete_Row': deleteIcon,
  'Edit_Pencil_01': edit,
  'Edit_Pencil_02': editPencil,
  'Paste': paste,
  'Redo': redo,
  'Undo': undo,
  'Remove_Minus': minus,
  'Remove_Minus_Circle': minusSm,
  'Add_Plus': plus,
  'Add_Plus_Circle': plusSm,

  // Environment Icons
  'Bulb': bulb,
  'Coffe_To_Go': coffeeToGo,
  'Coffee': coffee,
  'Cookie': cookie,
  'Cupcake': cupcake,
  'First_Aid': firstAid,
  'Leaf': leaf,
  'Moon': moon,
  'Planet': planet,
  'Puzzle': puzzle,
  'Rainbow': rainbow,
  'Sun': sun,
  'Water_Drop': waterDrop,

  // File Icons
  'Archive': archive,
  'Cloud': cloud,
  'Cloud_Add': cloudAdd,
  'Cloud_Check': cloudCheck,
  'Cloud_Close': cloudClose,
  'Cloud_Download': cloudDownload,
  'Cloud_Off': cloudOff,
  'Cloud_Remove': cloudRemove,
  'Cloud_Upload': cloudUpload,
  'File_Add': fileAdd,
  'File_Blank': fileBlank,
  'File_Check': fileCheck,
  'File_Close': fileClose,
  'File_Code': fileCode,
  'File_Document': fileDocument,
  'File_Download': fileDownload,
  'File_Edit': fileEdit,
  'File_Remove': fileRemove,
  'File_Search': fileSearch,
  'File_Upload': fileUpload,
  'Files': files,
  'Folder': folder,
  'Folder_Add': folderAdd,
  'Folder_Check': folderCheck,
  'Folder_Close': folderClose,
  'Folder_Code': folderCode,
  'Folder_Document': folderDocument,
  'Folder_Download': folderDownload,
  'Folder_Edit': folderEdit,
  'Folder_Open': folderOpen,
  'Folder_Remove': folderRemove,
  'Folder_Search': folderSearch,
  'Folder_Upload': folderUpload,
  'Folders': folders,
  'Note': note,
  'Note_Edit': noteEdit,
  'Note_Search': noteSearch,
  'Notebook': notebook,

  // Interface Icons
  'Book': book,
  'Book_Open': bookOpen,
  'Bookmark': bookmark,
  'Chart_Bar_Horizontal_01': chartBarHorizontal,
  'Chart_Bar_Vertical_01': chartBarVertical,
  'Chart_Line': chartLine,
  'Chart_Pie': chartPie,
  'Check': check,
  'Check_All': checkAll,
  'Check_All_Big': checkAllBig,
  'Check_Big': checkBig,
  'Checkbox_Check': checkboxCheck,
  'Checkbox_Fill': checkboxFill,
  'Checkbox_Unchecked': checkboxUnchecked,
  'Command': command,
  'Credit_Card_01': creditCard01,
  'Credit_Card_02': creditCard02,
  'Download': download,
  'Drag_Horizontal': dragHorizontal,
  'Drag_Vertical': dragVertical,
  'Dummy_Circle': dummyCircle,
  'Dummy_Circle_Small': dummyCircleSmall,
  'Dummy_Square': dummySquare,
  'Dummy_Square_Small': dummySquareSmall,
  'Exit': exit,
  'External_Link': externalLink,
  'Filter': filter,
  'Filter_Off': filterOff,
  'Gift': gift,
  'Handbag': handbag,
  'Heart_01': heart01,
  'Heart_02': heart02,
  'Instance': instance,
  'Label': label,
  'Line_L': lineL,
  'Line_M': lineM,
  'Line_S': lineS,
  'Line_Xl': lineXl,
  'Link': link,
  'Link_Break': linkBreak,
  'Link_Horizontal': linkHorizontal,
  'Link_Horizontal_Off': linkHorizontalOff,
  'Link_Vertical': linkVertical,
  'Loading': loading,
  'Lock': lock,
  'Lock_Open': lockOpen,
  'Log_Out': logOut,
  'Magnifying_Glass_Minus': magnifyingGlassMinus,
  'Magnifying_Glass_Plus': magnifyingGlassPlus,
  'Main_Component': mainComponent,
  'Option': option,
  'Radio_Fill': radioFill,
  'Radio_Unchecked': radioUnchecked,
  'Search_Magnifying_Glass': search,
  'Settings': settings,
  'Settings_Future': settingsFuture,
  'Shopping_Bag_01': shoppingBag01,
  'Shopping_Bag_02': shoppingBag02,
  'Shopping_Cart_01': shoppingCart01,
  'Shopping_Cart_02': shoppingCart02,
  'Slider_01': slider01,
  'Slider_02': slider02,
  'Slider_03': slider03,
  'Star': star,
  'Suitcase': suitcase,
  'Swicht_Left': swichtLeft,
  'Swicht_Right': swichtRight,
  'Tag': tag,
  'Ticket_Voucher': ticketVoucher,
  'Trash_Empty': trashEmpty,
  'Trash_Full': trashFull,
  'Trending_Down': trendingDown,
  'Trending_Up': trendingUp,

  // Media Icons
  'Airplay': airplay,
  'Chromecast': chromecast,
  'Forward': forward,
  'Headphones': headphones,
  'Image_01': image01,
  'Image_02': image,
  'Pause': pauseIcon,
  'Pause_Circle': pauseCircle,
  'Play': playIcon,
  'Play_Circle': playCircle,
  'Rewind': rewind,
  'Shuffle': shuffle,
  'Skip_Back': skipBack,
  'Skip_Forward': skipForward,
  'Stop': stopIcon,
  'Stop_Circle': stopCircle,
  'Volume_Max': volumeMax,
  'Volume_Min': volumeMin,
  'Volume_Minus': volumeMinus,
  'Volume_Off': volumeOff,
  'Volume_Off_02': volumeOff02,
  'Volume_Plus': volumePlus,

  // Menu Icons
  'Hamburger_LG': menu,
  'Hamburger_MD': menuMd,
  'Menu_Alt_01': menuAlt1,
  'Menu_Alt_02': menuAlt2,
  'Menu_Alt_03': menuAlt3,
  'Menu_Alt_04': menuAlt4,
  'Menu_Alt_05': menuAlt5,
  'Menu_Duo_LG': menuDuoLg,
  'Menu_Duo_MD': menuDuoMd,
  'Close_LG': close,
  'Close_MD': closeMd,
  'Close_SM': closeSm,
  'More_Grid_Big': moreGridBig,
  'More_Grid_Small': moreGridSmall,
  'More_Horizontal': ellipsis,
  'More_Vertical': moreVertical,

  // Navigation Icons
  'Building_01': building01,
  'Building_02': building02,
  'Building_03': building03,
  'Building_04': building04,
  'Car_Auto': carAuto,
  'Compass': compass,
  'Flag': flag,
  'Globe': globe,
  'House_01': home,
  'House_02': homeAlt1,
  'House_03': homeAlt2,
  'House_Add': homeAdd,
  'House_Check': homeCheck,
  'House_Close': homeClose,
  'House_Remove': homeRemove,
  'Map': map,
  'Map_Pin': mapPin,
  'Navigation': navigation,

  // Shape Icons
  'Circle': circle,
  'Octagon': octagon,
  'Shield': shield,
  'Square': square,
  'Triangle': triangle,
  'Wavy': wavy,
  'Negative': Negative,
  'Positive': Positive,

  // System Icons
  'Bar_Bottom': barBottom,
  'Bar_Left': barLeft,
  'Bar_Right': barRight,
  'Bar_Top': barTop,
  'Camera': systemCamera,
  'Code': code,
  'Cylinder': cylinder,
  'Data': data,
  'Desktop': desktop,
  'Desktop_Tower': desktopTower,
  'Devices': devices,
  'Keyboard': keyboard,
  'Laptop': laptop,
  'Mobile': mobile,
  'Mobile_Button': mobileButton,
  'Monitor': monitor,
  'Monitor_Play': monitorPlay,
  'Mouse': mouse,
  'Moving_Desk': movingDesk,
  'Printer': printer,
  'Qr_Code': qrCode,
  'Save': save,
  'Tablet': tablet,
  'Tablet_Button': tabletButton,
  'Terminal': terminal,
  'Wifi_High': wifiHigh,
  'Wifi_Low': wifiLow,
  'Wifi_Medium': wifiMedium,
  'Wifi_None': wifiNone,
  'Wifi_Off': wifiOff,
  'Wifi_Problem': wifiProblem,
  'Window': window,
  'Window_Check': windowCheck,
  'Window_Close': windowClose,
  'Window_Code_Block': windowCodeBlock,
  'Window_Sidebar': windowSidebar,
  'Window_Terminal': windowTerminal,

  // User Icons
  'User_01': user01,
  'User_02': user02,
  'User_03': user03,
  'User_Add': userAdd,
  'User_Card_ID': userCardId,
  'User_Check': userCheck,
  'User_Circle': userCircle,
  'User_Close': userClose,
  'User_Remove': userRemove,
  'User_Square': userSquare,
  'User_Voice': userVoice,
  'Users': users,
  'Users_Group': usersGroup,

  // Warning Icons
  'Circle_Check': circleCheck,
  'Circle_Help': question,
  'Circle_Warning': alert,
  'Help': help,
  'Info': info,
  'Octagon_Check': octagonCheck,
  'Octagon_Help': octagonHelp,
  'Octagon_Warning': octagonWarning,
  'Shield_Check': shieldCheck,
  'Shield_Warning': shieldWarning,
  'Square_Check': squareCheck,
  'Square_Help': squareHelp,
  'Square_Warning': squareWarning,
  'Stop_Sign': stopSign,
  'Triangle_Check': triangleCheck,
  'Triangle_Warning': alertTriangle,
  'Warning': warning,
  'Wavy_Check': wavyCheck,
  'Wavy_Help': wavyHelp,
  'Wavy_Warning': wavyWarning,
};

export default icons;
